export default {
  intentOverview: "概要",
  intentAnalytic: "分析",
  intentFilter: "フィルター",
  savedCompanyWebsite: "保存済み企業ウェブサイト",
  companiesFound: "企業が見つかりました",
  companyFound: "企業が見つかりました",
  selectLists: "リストを選択...",
  chooseARangeOfTime: "期間を選択",
  greaterThan: "より大きい",
  // intentIndustry: '産業',
  tabActivity: "活動",
  tabOverview: "概要",
  tabEmployees: "従業員",
  tabContacts: "連絡先",
  tabTechnologies: "テクノロジー",
  intentStatistic: "統計",
  intentCampaign: "キャンペーン",
  newVisitors: "新規訪問者",
  recurringVisitors: "リピーター",
  mediocreLead: "普通のリード",
  sessionsTracked: "追跡されたセッション",
  sessionTracked: "追跡されたセッション",
  lastSeenOn: "最後に見た日：",
  firstSeenOn: "最初に見た日：",
  viewTrackedWebSession: "追跡されたウェブセッションを表示",
  webSession: "ウェブセッション",
  client: "クライアント",
  timeSpent: "滞在時間",
  pageviews: "ページビュー",
  pageview: "ページビュー",
  referrer: "参照元",
  sessions: "セッション",
  session: "セッション",
  visited: "訪問済み",
  AM: "午前",
  PM: "午後",
  companyDetails: "企業詳細",
  overviewList: {
    location: "所在地",
    industry: "産業",
    founded: "設立",
    ranking: "ランキング",
    size: "規模",
    revenue: "推定収益",
    keywords: "キーワード",
  },
  jobFunction: "職務",
  employeeLocation: "所在地",
  contactEmail: "Eメール",
  categoryAndTechnology: "カテゴリーとテクノロジー",
  firstDetected: "最初に検出",
  lastDetected: "最後に検出",
  saved: "保存済み",
  addToContactList: "連絡先リストに追加",
  noCampaignIdentified: "キャンペーンは特定されていません",
  copyEmail: "Eメールをコピー",
  willBeSavedToTheFollowingSelectedLists:
    "以下の選択されたリストに保存されます：",
  addToLists: "リストに追加",
  noDataToDisplay: "表示するデータがありません",
  intentFounded: "設立",
  intentIndustry: "産業",
  intentLocation: "所在地",
  intentRanking: "ランキング",
  noDetailsAvailableRightNow : "現在利用可能な詳細情報はありません。後でご確認ください。",
  intentSize: "規模",
  applyFilters: "フィルターを適用",
  youCanEditTheseFilters:
    "これらのフィルターはいつでも編集して、結果を絞り込むことができます",
  installB2BDirectLeadFinder: "サイトにB2B Direct Lead Finderをインストールする",
  addSite: "あなたのウェブサイトを追加する",
  areYouSureYouWantToRemoveThisWebsite:
    "このウェブサイトを削除してもよろしいですか？",
  Cancel: "キャンセル",
  installB2BLeadFinder: "B2B Lead Finderをインストール",
  siteUrl: "サイトURL",
  copyToClipboard: "クリップボードにコピー",
  pleaseSelectAContactFirst: "最初に連絡先を選択してください",
  pasteCodeBelowIntoTheHead: "以下のコードを",
  ofEveryPageYouWishToTrackVisitorOn:
    "訪問者を追跡したいすべてのページの<head>セクション</head>に貼り付けてください。",
  forWordpressWeRecommendInstalling:
    "Wordpressの場合、",
  pluginFromStefanoLissa: "Stefano Lissa氏のプラグインをインストールすることをお勧めします。",
  afterInstallingAndActivating:
    "プラグインをインストールして有効化した後、WordPressダッシュボードの",
  inYourWordPressDashboard: "に移動してください。",
  youWillSeeANumberOfTabs:
    "プラグインのインターフェースにはいくつかのタブが表示されます。デフォルトの「Head and footer」タブにいることを確認し、以下のコードスニペットをコピー＆ペーストしてください：",
  settingHeaderAndFooter: "設定 → ヘッダーとフッター",
  dontForgetToClearYourCache: "キャッシュをクリアすることを忘れないでください",
  ifYouAreUsingAnyCaChing: "キャッシュプラグイン（例：",
  orSimilar:
    "など）を使用している場合は、コードスニペットをインストールした後、必ずキャッシュをクリアしてください！",
  GTMshouldAlreadyBeInstalled:
    "これらの手順に従う前に、Google Tag Managerがすでにサイトにインストールされている必要があります。",
  ifYouDontHaveGTM:
    "Google Tag Managerがまだインストールされていない場合は、",
  GTMsupportArticleAboutInstall:
    "Google Tag Managerのサポート記事でインストール方法を確認できます",
  signInToGTMAndClick:
    "Google Tag Managerにサインインし、「新しいタグを追加」ボタンをクリックします。次に、",
  clickWhereItSays: "と表示されている場所をクリックし、",
  chooseATagTypeToBeginSetup: "設定を開始するタグタイプを選択",
  andSelect: "を選択してください。",
  fromTheList:
    "リストから。次に、以下のコードをコピー＆ペーストしてテキストフィールドに貼り付けてください：",
  nextClick: "次に、「",
  giveTheTagAName: "」をクリックしてください。タグに名前を付けて、「保存」ボタンをクリックします。",
  dontForgetToPublishYourChange: "変更を公開することを忘れないでください",
  afterCreateTheCustom: "カスタムHTMLタグを作成した後、",
  yourChanges: "変更を公開することを忘れないでください！",
  submitAndPublish: "送信と公開",
  copySuccessfully: "正常にコピーされました",
  addToCompanyList: "企業リストに追加",
  addToList: "リストに追加",
  enterOrCreateList: "リストを入力または作成",
  installCode: "コードをインストール",
  wordpress: "Wordpress",
  googleTagManager: "Google Tag Manager",
  noTechAreFound: "テクノロジーは見つかりませんでした",
  updateSuccessfully: "正常に更新されました",
  enterJobFunction: "職務を入力",
  pinSuccessfully: "正常にピン留めされました",
  cancelPinSuccessfully: "正常にピン留めが解除されました",
  adsName: "広告名",
  utmTerm: "utmキーワード",
  utmCampaign: "utmキャンペーン",
  utmSource: "utmソース",
  utmMedium: "utmメディア",
  enterNumber: "数値を入力",
  enterName: "名前を入力",
  enterJobTitle: "役職を入力",
  areYouSureYouWantToRemovePeopleOfThisGroup:
    "このグループの人々を削除してもよろしいですか？",
  areYouSureYouWantToRemoveCompanyOfThisGroup:
    "このグループの企業を削除してもよろしいですか？",
  byCancelingYouEnsureThatNoPeopleWillBeRemoved:
    "キャンセルすると、誰も削除されないことが保証されます。",
  byCancelingYouEnsureThatNoCompanyWillBeRemoved:
    "キャンセルすると、企業が削除されないことが保証されます。",
  howToGetStarted: "開始方法",
  Data: "データ",
  deactivateWebsite: "ウェブサイトを非アクティブ化",
  areYouCertainAboutDeactivatinYourWebsite:
    "ウェブサイトを非アクティブ化してもよろしいですか？これにより、潜在的な企業活動に関する通知を受け取れなくなります。",
  byCancelingYouWillContinueToActivateAndUse:
    "キャンセルすると、このツールは引き続きアクティブになり使用されます。",
  btnDeactivateNow: "今すぐ非アクティブ化",
  yourTrialHasEnded: "トライアルが終了しました",
  reactivateNow: "今すぐ再アクティブ化",
  yourWebsiteHasBeenAutomaticallyInactivated:
    "あなたのウェブサイトは自動的に非アクティブ化されました。データの監視を続けるために、このツールを再アクティブ化しますか？",
  Inactivated: "非アクティブ化",
  onTrial: "トライアル中",
  Active: "アクティブ",
  youAreOnTrail: "7日間のトライアル中です",
  yourTrailHasEnded: "トライアルが終了しました",
  createNewWebIntent: "新しいウェブインテントを作成",
  clickOnTheButton: "1. (+) ボタンをクリックします。",
  typeInUrlOrWebAddress: "2. URLまたはウェブアドレスを入力します。",
  theTrialWillActivate: "このサイトの7日間無料トライアルを有効にしてください",
  siteUrlMustStartWithHttps: "サイトURLはhttpsまたはhttpで始まる必要があります",
  pleaseEnterASiteUrl: "サイトURLを入力してください",
  noMoreData: "これ以上データはありません",
  pleaseEnterANewName: "新しい名前を入力してください",
  pleaseSelectASearchName: "検索名を選択してください",
  clickToGetEmail: "クリックしてEメールを取得",
  emailIsNotAvailable: "Eメールは利用できません",
  enterOrCreateLists: "リストを入力または作成",
  viewMore: "もっと見る",
  removeFromContactList: "連絡先リストから削除",
  willBeRemovedFromTheFollowingLists:
    "以下のリストから削除されます",
  removeFromLists: "リストから削除",
  pleaseSelectOrCreateAList: "リストを選択または作成してください",
  chooseATriggerToMakeThisTagFire: "このタグを起動するトリガーを選択してください...",
  youWontBeChargedYet: "まだ請求されません",
  youDontHaveEnoughCredits: "十分なクレジットがありません",
  ThisEmailRequire: "このEメールには",
  TheseEmailsRequires: "これらのEメールには",
  intentCredit: "クレジットが必要です",
  intentCredits: "クレジットが必要です",
  companyOverview: '企業概要',

  // 新UI
  companyInsight: "企業インサイト",
  companiesDetailHeader: "企業",
  updateData: "データを更新",
  discoverYourLeads: "リードを発見",
  similarCompanies: "類似企業",
  companyEmployees: "従業員"
};